export const ADD_EXPOSED_AB_TEST = "ADD_EXPOSED_AB_TEST";

export const addExposedAbTest = abTestData => ({
	type: ADD_EXPOSED_AB_TEST,
	payload: abTestData,
});

const abTestsReducer = (state = {}, action) => {
	switch (action.type) {
		case ADD_EXPOSED_AB_TEST: {
			const existing = state.exposedTests || [];
			const filtered = existing.filter(test => test.abTestName !== action.payload.abTestName);
			return {
				...state,
				exposedTests: [...filtered, action.payload],
			};
		}
		default:
			return state;
	}
};

export default abTestsReducer;
